const getters = {
  list: (state) => state.list,
  requestInProgress: (state) => state.requestInProgress,
  replacementReasons: (state) => {
    const { allReasons, reasonGroups } = state["requestFlow"].replacement;
    return { allReasons, reasonGroups };
  },
};

export default getters;
